import http from "./http";
import type { IUser } from "../models/user_model";

export const getUsers = async (nombreFilter?: string, emailFilter?: string) => {
  try {
    const filters = []
    if (nombreFilter) {
      filters.push(`nombre=${nombreFilter}`)
    }
    if (emailFilter) {
      filters.push(`email=${emailFilter}`)
    }
    const items = await http.get<IUser[]>(`/usuario/${filters.length ? ('?' + filters.join('&')) : ''}`);
    return items.filter((item) => item.rol !== 'PADRE')
  } catch (error) {
    console.error("[get_usuarios]  Error -> ", error);
    return [];
  }
};

export const createUser = async (data: IUser) => {
  try {
    return await http.post<IUser, IUser>(`/usuario/`, data);
  } catch (error) {
    console.error("Ocurrio un error al guardar usuario :: ", error);
    return null;
  }
};

export const editUser = async (data: Partial<IUser>, id: string) => {
  try {
    return await http.put<IUser, Partial<IUser>>(`/usuario/${id}`, data);
  } catch (error) {
    console.error("Ocurrio un error al editar usuario :: ", error);
    return null;
  }
};

export const deleteUser = async (id: string) => {
  try {
    return await http.delete(`/usuario/${id}`);
  } catch (error) {
    console.error("Error al eliminar usuario :: ", error);
    return null;
  }
};

export const changePassword = async (newPass: string) => {
  try {
    await http.post('/usuario/cambiarPass', { password: newPass });
    return true;
  } catch (error) {
    console.error("Error al cambiar la contraseña :: ", error);
    return false;
  }
};
